import React from "react";
import { Button, Icon, Paragraph, Title } from "@sicredi/react";
import { useHistory } from "react-router-dom";
import styles from "./styles.module.scss";

declare global {
  interface Window {
    dataLayer: [Record<string, number | string>];
  }
}

type Props = {
  setIsOpen: (value: boolean) => void;
};

export function FixedNavigation({ setIsOpen }: Props) {
  const history = useHistory();
  function handleNavigate(route: string): void {
    history.push(route);
  }
  function handlerNextPage(item: {
    id: number;
    label: string;
    routerOrhref: string;
    route: boolean;
  }): void {
    if (item.route === true) {
      setIsOpen(false);
      handleNavigate(item.routerOrhref);
    } else {
      window.open(item.routerOrhref);
    }
  }

  const items = [
    {
      id: 1,
      label: "Resgate de Milhas",
      routerOrhref: "/resgate-de-milhas",
      route: true,
    },
    {
      id: 2,
      label: "Plataforma de Viagens",
      routerOrhref: "/plataforma-de-viagens",
      route: true,
    },
  ];

  return (
    <div className={styles["other-links"]}>
      {items.map((item) => (
        <Button
          data-testid={`other-links${item.id}`}
          key={item.id}
          className={styles["menu-button"]}
          onClick={() => handlerNextPage(item)}
        >
          <Paragraph
            style={{
              color: "#3fa110",
            }}
          >
            {item.label}
          </Paragraph>
          <Icon name="chevron-right" />
        </Button>
      ))}
    </div>
  );
}

export function FixedCategories() {
  function handlerNextPage(item: {
    id: number;
    label: string;
    routerOrhref: string;
    route: boolean;
  }): void {
    window.open(item.routerOrhref);
  }

  const items = [
    {
      id: 1,
      label: "Shopping",
      routerOrhref: "https://shopping.sicredi.com.br/",
      route: false,
    },
    {
      id: 2,
      label: "Crédito",
      routerOrhref: "https://www.sicredi.com.br/site/credito/para-voce/",
      route: false,
    },
    {
      id: 3,
      label: "Consórcio Sicredi",
      routerOrhref: "https://www.sicredi.com.br/site/consorcios/",
      route: false,
    },
    {
      id: 4,
      label: "Seja um associado Sicredi",
      routerOrhref:
        "https://www.sicredi.com.br/site/seja-associado/?utm_source=SPD_sejassociado_menu_site&utm_medium=SPD_sejassociado_menu_site_associacoes&utm_campaign=SPD_sejassociado_menu&utm_id=SPD_sejassociado_menu&utm_term=SPD_sejassociado_menu2112",
      route: false,
    },
  ];

  return (
    <div className={styles["other-links"]}>
      <Title as="h5">Conheça também</Title>
      {items.map((item) => (
        <Button
          data-testid={`other-links${item.id}`}
          key={item.id}
          className={styles["menu-button"]}
          onClick={() => handlerNextPage(item)}
          style={{ cursor: "pointer" }}
        >
          <Paragraph
            style={{
              color: "#3fa110",
            }}
          >
            {item.label}
          </Paragraph>
          <Icon name="chevron-right" />
        </Button>
      ))}
    </div>
  );
}
